// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__cLePU","errorImg":"ErrorPage_errorImg__dgjn0","errorTitle":"ErrorPage_errorTitle__NwhXN","errorText":"ErrorPage_errorText__aY63I"};